import { render, staticRenderFns } from "./BlacklistedContactsTable.vue?vue&type=template&id=b6d996e8&scoped=true"
import script from "./BlacklistedContactsTable.vue?vue&type=script&lang=js"
export * from "./BlacklistedContactsTable.vue?vue&type=script&lang=js"
import style0 from "./BlacklistedContactsTable.vue?vue&type=style&index=0&id=b6d996e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d996e8",
  null
  
)

export default component.exports